import React from "react";
import {
  AppBar
} from "@mui/material";
import HeaderTop from "../header/HeaderTop";
import HeaderBelow from "../header/HeaderBelow";
const Header = ({ open, setOpen, notification, setNotification, setProfile, profile, logout, setLogout, company, setCompany, cantine, setCantine,production,setProduction }) => {
  return (
    <AppBar
      className="dashboardHeader"
      position="static"
      color="transparent"
      elevation={0}
    >
      <HeaderTop open={open} setOpen={setOpen} notification={notification} setNotification={setNotification}
        setProfile={setProfile} profile={profile} setLogout={setLogout} logout={logout} company={company} setCompany={setCompany}
      />
      <HeaderBelow cantine={cantine}
        setCantine={setCantine}
        production={production}
        setProduction={setProduction}
        />
    </AppBar>
  );
};

export default Header;
